import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  getNatureOfGoods,
  getPublicPackages,
} from '../../../api/shipmentForms';
import { useShipForm } from '../../../context/shipForms';
import {
  ShipmentPackageValidationValues,
  packagesFormInitialValue,
  packagesMetricOptions,
} from '../../../initial-values';
import { AddressDto, ReferenceRouteFormDto } from '../../../types';
import { mapPayloadForRatesQuote } from '../../../utils/helper';
import CustomSelect from '../../global-components/select';
import ManualShipmentLegs from '../../manual-shipments/legs';
import MainRatesPage from '../rates';
import PackageBox from './packageBox';
import PackagesFields from './packagesFields';
import MainInternationalPage from '../international';

interface Props {
  setShowAttention: any;
  setShowPackages: any;
  setCurrentShipmentStatus: any;
  isOpenedFromSummary?: boolean;
  isQuote?: boolean;
}

function PackagesContainer({
  setShowAttention,
  setShowPackages,
  setCurrentShipmentStatus,
  isOpenedFromSummary,
  isQuote,
}: Props) {
  const {
    getDestinationFormData,
    getOriginFormData,
    getSelectedCarrierContext,
    setRatesApiPayloadContext,
    setSelectedRateContext,
    setSelectedATALegsInfo,
    getIsMetricContext,
    getSavedQuoteFormDataContext,
    getReferenceFormDataContext,
    getRatesApiPayloadContext,
  } = useShipForm();
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const isManualShipment = location.pathname === '/app/admin/manual-shipments';
  const destinationFormContextData: AddressDto = getDestinationFormData();
  const originFormContextData: AddressDto = getOriginFormData();
  const selectedCarriersContext: any = getSelectedCarrierContext();
  const savedQuoteContextData: any = getSavedQuoteFormDataContext();
  const metricAndFoodContext: any = getIsMetricContext();
  const ratesApiPayloadContext: any = getRatesApiPayloadContext();
  const referenceFormContextData: ReferenceRouteFormDto =
    getReferenceFormDataContext();

  const contextPackages = ratesApiPayloadContext?.packages
    ? ratesApiPayloadContext?.packages
    : savedQuoteContextData?.quoteData?.packages;

  const [showratesForm, setShowRatesForm] = useState(false);
  const [showInternationScreenForm, setShowInternationScreenForm] =
    useState(false);
  const [showManualLegsForm, setShowManualLegsForm] = useState(false);
  const [isMetric, setIsMetric] = useState(true);
  const [isFood, setIsFood] = useState(
    ratesApiPayloadContext?.is_food === true ? true : false
  );
  const [loading, setLoading] = useState(false);
  const [editPackageId, setEditPackageId] = useState('');
  const [packagesList, setPackagesList] = useState<any[]>(
    contextPackages ? contextPackages : []
  );
  const [iseditPackage, setIsEditPackage] = useState(false);

  const [packageTypeData, setPackageTypeData] = useState<any>();
  const [natureOfGoodsData, setNatureOfGoodsData] = useState<any>();
  const [packagesForm, setPackagesForm] = useState<any>(
    packagesFormInitialValue
  );
  const [addPackageValidations, setAddPackageValidations] = useState<any>(
    ShipmentPackageValidationValues
  );
  function backRoute() {
    setShowPackages(false);
    setShowAttention(false);
    setCurrentShipmentStatus('route');
  }
  function nextPackages() {
    setSelectedRateContext(null);
    setSelectedATALegsInfo(null);
    if (packagesList && packagesList.length > 0) {
      let payloadOfPackages = mapPayloadForRatesQuote(
        destinationFormContextData,
        originFormContextData,
        selectedCarriersContext,
        packagesList,
        isFood,
        isMetric,
        referenceFormContextData
      );
      setRatesApiPayloadContext(payloadOfPackages);
      if (isManualShipment) {
        setShowManualLegsForm(true);
        setCurrentShipmentStatus('legs');
        window.scrollTo(0, 0);
      } else {
        goToRatesScreen(payloadOfPackages);
      }
    } else {
      enqueueSnackbar('Please add atleast one package.', { variant: 'error' });
    }
  }
  function goToRatesScreen(payload: any) {
    // setLoading(true);
    setCurrentShipmentStatus('rates');
    setRatesApiPayloadContext(payload);
    //go to internation screen
    const isOriginOutsideCanada = originFormContextData.country !== 'CA';
    const isDestinationOutsideCanada =
      destinationFormContextData.country !== 'CA';
    const isSameCountry =
      originFormContextData.country !== destinationFormContextData.country;
    const shouldApplyCondition =
      !isQuote &&
      isSameCountry &&
      (isOriginOutsideCanada || isDestinationOutsideCanada);
    if (shouldApplyCondition) {
      setShowInternationScreenForm(true);
    } else {
      setShowRatesForm(true);
    }
    window.scrollTo(0, 0);
  }
  function getPublicPackagesApi() {
    getPublicPackages()
      .then((response) => {
        setPackageTypeData(response?.data?.content?.data);
      })
      .catch((e) => {
        console.log(e);
      });
  }
  function getNatureOfGoodsApi() {
    getNatureOfGoods(isFood)
      .then((response) => {
        setNatureOfGoodsData(response?.data?.content?.nogs);
      })
      .catch((e) => {
        console.log(e);
      });
  }
  useEffect(() => {
    if (ratesApiPayloadContext) {
      setIsMetric(ratesApiPayloadContext?.is_metric === false ? false : true);
      setIsFood(ratesApiPayloadContext?.is_food === true ? true : false);
    } else if (metricAndFoodContext) {
      setIsMetric(metricAndFoodContext.isMetric === false ? false : true);
      setIsFood(metricAndFoodContext?.is_food === true ? true : false);
    }
    getPublicPackagesApi();
    getNatureOfGoodsApi();
  }, []);

  useEffect(() => {
    setPackagesForm({
      ...packagesForm,
      nog_id: isFood ? '179' : '302',
      units: isMetric ? '0' : '1',
    });
    getNatureOfGoodsApi();
  }, [isFood]);
  useEffect(() => {
    if (packagesList && packagesList.length > 0) {
      setPackagesList((prevPackagesList: any) => {
        return prevPackagesList.map((pkg: any) => {
          const updatedPackage = { ...pkg };
          updatedPackage.units = isMetric ? '0' : '1';
          return updatedPackage;
        });
      });
    }
    setPackagesForm({
      ...packagesForm,
      units: isMetric ? '0' : '1',
    });
  }, [isMetric]);

  useEffect(() => {
    if (!isMetric && packagesForm?.units === '0') {
      setPackagesForm({
        ...packagesForm,
        units: isMetric ? '0' : '1',
      });
    }
  }, [packagesForm]);
  useEffect(() => {
    if (contextPackages) {
      setPackagesList(contextPackages);
      if (ratesApiPayloadContext) {
        setIsMetric(ratesApiPayloadContext?.is_metric === false ? false : true);
        setIsFood(ratesApiPayloadContext?.is_food === true ? true : false);
      } else if (metricAndFoodContext) {
        setIsMetric(metricAndFoodContext.isMetric === false ? false : true);
        setIsFood(metricAndFoodContext?.is_food === true ? true : false);
      }
    }
  }, [showInternationScreenForm]);

  return (
    <div>
      {loading && (
        <div className='loader-container'>
          <div className='spinner'></div>
        </div>
      )}
      {showratesForm ? (
        <MainRatesPage
          setShowRatesForm={setShowRatesForm}
          setCurrentShipmentStatus={setCurrentShipmentStatus}
        />
      ) : showManualLegsForm ? (
        <ManualShipmentLegs
          setShowLegsForm={setShowManualLegsForm}
          setCurrentShipmentStatus={setCurrentShipmentStatus}
        />
      ) : showInternationScreenForm ? (
        <MainInternationalPage
          setShowInternationScreenForm={setShowInternationScreenForm}
          setCurrentShipmentStatus={setCurrentShipmentStatus}
          setShowRatesForm={setShowRatesForm}
        />
      ) : (
        <div className='row mt-2'>
          <div className='col-md-12 col-lg-6'>
            <div className='ubbe-card'>
              <div className='ubbe-card-header'>
                <h5 className='ps-3 mb-0'>Packages Details</h5>
              </div>
              <div className='card-body p-4'>
                <PackagesFields
                  packageTypeData={packageTypeData}
                  packagesForm={packagesForm}
                  setPackagesForm={setPackagesForm}
                  natureOfGoodsData={natureOfGoodsData}
                  packagesList={packagesList}
                  setPackagesList={setPackagesList}
                  editPackageId={editPackageId}
                  setEditPackageId={setEditPackageId}
                  addPackageValidations={addPackageValidations}
                  setAddPackageValidations={setAddPackageValidations}
                  setIsEditPackage={setIsEditPackage}
                />
              </div>
            </div>
          </div>

          <div className='col-md-12 col-lg-6'>
            <div className='ubbe-card'>
              <div className='ubbe-card-header'>
                <h5 className='ps-3 mb-0'>Additional Details</h5>
              </div>
              <div className='card-body pb-4 px-4'>
                <div className='row'>
                  <div className='col-md-12'>
                    <label className='dropdown-label '>Unit</label>
                    <CustomSelect
                      id={'status-dropdown'}
                      value={isMetric ? '0' : '1'}
                      onChange={(e: any) => {
                        setIsMetric(e.target.value === '0');
                      }}
                      className={'form-select ubbe-input'}
                      options={packagesMetricOptions}
                    />
                  </div>
                  <div className='col-md-12 text-center'>
                    <div className='form-check mt-3 d-flex gap-2 align-items-center'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        checked={isFood}
                        id='is_food'
                        onChange={(e) => {
                          setIsFood(e.target.checked);
                        }}
                      />
                      <label
                        className='form-check-label global-text mb_0 globalInputLabel'
                        style={{ fontWeight: '300', marginTop: '2px' }}
                        htmlFor={'is_food'}
                      >
                        Are you shipping food?
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='mt-2' id='package_list'>
              {packagesList &&
                packagesList.length > 0 &&
                packagesList.map((pkg: any, index: number) => (
                  <PackageBox
                    index={index}
                    data={pkg}
                    setIsEditPackage={setIsEditPackage}
                    iseditPackage={iseditPackage}
                    packagesList={packagesList}
                    setPackagesList={setPackagesList}
                    setPackagesForm={setPackagesForm}
                    setEditPackageId={setEditPackageId}
                    addPackageValidations={addPackageValidations}
                    setAddPackageValidations={setAddPackageValidations}
                  />
                ))}
            </div>
          </div>
          <div className='d-flex my-5 justify-content-between align-items-center'>
            <div className=''>
              <p
                className='btn btn-ubbe-new-back d-flex gap-2'
                onClick={() => {
                  !isOpenedFromSummary && backRoute();
                }}
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='15'
                  height='8'
                  viewBox='0 0 15 8'
                  fill='none'
                >
                  <path
                    d='M3.03077 0.670207L0.176923 3.5735C0.123077 3.62828 0.0769229 3.69871 0.0461536 3.77697C0.0461536 3.7848 0.0461536 3.79262 0.0384613 3.80045C0.0153844 3.86305 -1.56239e-07 3.92566 -1.53161e-07 3.99609C-1.4632e-07 4.1526 0.0615383 4.30129 0.169231 4.41084L3.03077 7.32979C3.25385 7.55674 3.62308 7.55674 3.84615 7.32979C4.06923 7.10285 4.06923 6.72722 3.84615 6.50028L1.96154 4.58301L14.4231 4.58301C14.7385 4.58301 15 4.31694 15 3.99609C15 3.67524 14.7385 3.40917 14.4231 3.40917L1.96923 3.40917L3.84615 1.49972C3.96154 1.38234 4.01538 1.23365 4.01538 1.08496C4.01538 0.936277 3.96154 0.787591 3.84615 0.670207C3.62308 0.443265 3.26154 0.443265 3.03077 0.670207Z'
                    fill='black'
                  />
                </svg>
                Back
              </p>
            </div>
            <div className=''>
              <p
                className='btn btn-ubbe-new-blue'
                onClick={() => {
                  // next_packages()
                  nextPackages();
                }}
              >
                Continue
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default PackagesContainer;
